/**
 * Where we can actually transact software licences.
 *
 * WHY THIS EXISTS
 * Only ~32% of this site's traffic is US. A software-quote CTA shown to the
 * other 68% is worse than useless: the funnel invariant means that page carries
 * no ads, so a reader we cannot sell to sees a call to action they cannot act
 * on INSTEAD of an ad that would have earned something. Geo-gating turns that
 * dead impression back into revenue.
 *
 * Keep this list to countries where we can genuinely quote, invoice and
 * support. Adding one is a commercial decision — tax, entity and vendor
 * distribution rights — not a technical one.
 */
export const SELLABLE_COUNTRIES = ['US'] as const;

/**
 * True when we can sell to this country. Unknown country returns TRUE on
 * purpose: geo lookup fails for crawlers, privacy proxies and our own
 * previews, and in those cases showing the CTA is the recoverable error. A
 * wrongly hidden CTA loses a real buyer silently; a wrongly shown one loses
 * one ad impression.
 */
export function isSellableCountry(country?: string | null): boolean {
  if (!country) return true;
  return (SELLABLE_COUNTRIES as readonly string[]).includes(country.toUpperCase());
}
